//-------------Imports-------------//

import wixData from 'wix-data';
import wixLocation from 'wix-location';

//-------------Page Setup-------------//

$w.onReady(function () {
	// Load the products that are related to the currently displayed product using the loadRelatedProducts() function.
	loadRelatedProducts();
});

// Load the products that are related to the currently displayed product.
async function loadRelatedProducts() {
	// Get the current product's data.
	let product = await $w('#productPage1').getProduct();
	// Get the related product results using the relatedProductsByCollection() and relatedProductsByPrice() functions.
	let relatedProductResults = await //Promise.all([
		relatedProductsByCollection(product) /*,
		relatedProductsByPrice(product)
	]);*/

	// If there are related products found in the "related-products" collection:	
	if (relatedProductResults.length > 0)
		// Show the related products from the collection.
		showRelatedProducts(relatedProductResults);
	// // If there are no related products found in the "related-products" collection:	
	// else
	// 	// Fallback to showing the related products by price.
	// 	showRelatedProducts(relatedProductResults[1]);
}

// Get related products based on the relations set in the "related-products" collection.
async function relatedProductsByCollection(product) {
	// Get the current product's ID.
	let productId = product._id;

	// Find related products in the relationship collection by querying for related products in both relation directions.
	let relatedByTable = await 
		wixData.query('related-products')
		.eq('currProduct', productId)
		.include('relatedProduct')
		.find()

	// Merge related products found from both sides of the relationship collection.
	let relatedProducts = relatedByTable.items.map(_ => _.relatedProduct);

	//Return the related products found in the collection.
	return relatedProducts;
}

// // Get related products based on the the product prices.
// async function relatedProductsByPrice(product) {
// 	// Get the current product's ID.
// 	let productId = product._id;

// 	// Query the "Products" collection for product's whose price is within 20% of the current product's price.
// 	let relatedByPrice = await wixData.query('Stores/Products')
// 		.between('price', product.price * 0.8, product.price * 1.2)
// 		.ne('_id', productId)
// 		.find();
// 	// Return the related items extracted from the query results.
// 	return relatedByPrice.items;
// }

// Show the related products on the page.
function showRelatedProducts(relatedProducts) {
	// If there are any related products:
	if (relatedProducts.length > 0) {
		// Remove all but the first four related items.
		relatedProducts.splice(4, relatedProducts.length);
		// Set the function that runs when the related items repeater data is loaded to be relatedItemReady().
		$w('#relatedItemsRepeater').onItemReady(relatedItemReady);
		// Set the related items repeater data to the first four related items.
		$w("#relatedItemsRepeater").data = relatedProducts;
		// Expand the related items repeater.
		$w("#relatedStrip").expand();
	}
	// If there are no related products:
	else {
		// Collapse the related items repeater.
		$w("#relatedStrip").collapse();
	}
}

// Set up the related items repeater as its data is loaded.
function relatedItemReady($w, product) {
	// Populate the repeater elements from the item data.
	$w("#productImage").src = product.mainMedia;
	$w("#productName").text = product.name;
	$w("#productPrice").text = product.formattedPrice;
	// Set the action that occurs when the image is clicked.
	$w('#productImage').onClick(() => {
		// Navigate to the related product's product page.
		wixLocation.to(product.productPageUrl);
	});
}